<template>
  <div class="rentals-list-w">

    <WorklistFilters :filterFormData="filterFormData" @filterInterface="updateFilterFormData" :appliedFilters="appliedFilters" :filters="facets"
       v-show="toggleFilterState.display == 'Filters' && toggleFilterState.show == true"
    />
    <WorklistColumns @columnInterface="updateColumnFormData" v-show="toggleFilterState.display == 'Columns' && toggleFilterState.show == true" />

    <div class="rentals-list">
      <div class="list-controls">
        <div class="list-info export">
          <div class="btn-group mr-1 mb-1 mt-1">
            <button  class="btn btn-white export-button" type="button" @click="toggleFilters()">Filters</button>
          </div>
        </div>
        <div class="list-info export">
          <div class="btn-group mr-1 mb-1 mt-1">
            <button aria-expanded="false" aria-haspopup="true" class="btn btn-white dropdown-toggle export-button" data-toggle="dropdown" id="export-button" type="button">Export</button>
            <div aria-labelledby="export-button" class="dropdown-menu" x-placement="top-start">
              <a class="dropdown-item" @click="exportReport('quick_download')"> Quick Download</a>
              <a class="dropdown-item" @click="exportReport('pending_products')"> Export Pending</a>
              <a class="dropdown-item" @click="exportReport('scoped')"> Export Filtered</a>
              <a class="dropdown-item" @click="exportReport('all')"> Export All</a>
            </div>
          </div>
        </div>
        <div class="list-search">
          <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString" placeholder="Search worklist..." type="search"></div>
        </div>

        <div class="list-order">
          <label for="">Channel:</label>
          <select v-model="selectedChannel" @change="onChangeChannel" class="form-control-sm">
            <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
          </select>
          <label for="" class="ml-2">Location:</label>
          <select v-model="selectedLocation" @change="onChangeChannel" class="form-control-sm">
            <option value="0">All</option>
            <option v-for="location in locations" :value="location.id_client_location">{{location.name_en}}</option>
          </select>
        </div>
        <div class="list-order">
          <label for="">Mode:</label>
          <select v-model="selectedMode" @change="onChangeMode" class="form-control-sm">
            <option value="Workflow">Workflow</option>
            <option value="RMS">RMS</option>
          </select>
        </div>
      </div>
      <div class="property-items as-grid">
        <Loader v-if="loadingWorklist && !errorWorklist" />
        <Error v-if="errorWorklist" />
          <WorklistTable :modules="modules" :worklistdata="pagination" :worklistmovements="movements" :columns="[]" :searchString="searchString" :mode="selectedMode" @archiveInterface="archiveProduct" v-else />
      </div>
      <SimplePagination :pagination="pagination" @paginate="onChangeMode()"></SimplePagination>
    </div>

  </div>
</template>

<script>
import WorklistColumns from '@/components/reportdesk/WorklistColumns'
import WorklistFilters from '@/components/reportdesk/WorklistFilters'
import WorklistTable from '@/components/reportdesk/WorklistTable'
import SimplePagination from '@/components/common/SimplePagination'
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
import { debounce } from 'underscore'
import { MeiliSearch } from 'meilisearch'

export default {
  components: {
    WorklistColumns,
    WorklistFilters,
    WorklistTable,
    SimplePagination,
    Loader,
    Error
  },
  data: function () {
    return {
      loadingWorklist: false,
      errorWorklist: false,
      toggleState: {
        show: false,
        display: 'Filters'
      },
      pagination: {
        current_page: 1
      },
      RMSpagination: {
        current_page: 1
      },
      modules: [],
      channels: '',
      locations: 0,
      allLocations: 0,
      movements: '',
      appliedFilters: '',
      filterFormData: [],
      columnFormData: '',
      selectedChannel: '',
      selectedLocation: '',
      selectedMode: 'Workflow',
      searchString: '',
      isTyping: false,
      facets: {},
      filters: {
        category: [],
        gender: [],
        brand: [],
        season: []
      }
    }
  },
  mounted: function () {
    this.renderTable('mount')
  },
  methods: {
    archiveProduct(id_product) {
      if (confirm('Are you sure you want to archive this product? It will be dropped from downloaded worklists but will remain on UI')) {
        let data = {
          id_product: id_product,
        }
        const url = '/productdesk/product/archive/update'

        this.$http
          .post(url, data, {
            dataType: 'json',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          })
          .then(function (response) {
            alert('Product will be archived in a few minutes')
          })
          .catch(function (error) {
          })
      }
    },

    updateColumnFormData (data) {
      this.columnFormData = data
    },
    updateFilterFormData (data) {
      this.filterFormData = data
      this.getWorklistData()
    },
    renderTable (where) {
      if (this.selectedLocation && this.selectedChannel) {
        this.getWorklistData()
      } else {
        this.locations = this.$store.getters.clientLocations
        this.allLocations = this.$store.getters.clientAllLocations
        this.selectedLocation = 0
        this.channels = this.$store.getters.clientChannels
        this.selectedChannel = this.channels[0].id_channel
        this.modules = this.$store.getters.clientModules
        this.getWorklistData()
      }
    },
    async getWorklistData () {
      const client = new MeiliSearch({
        host: 'https://search.studiobridge.io/',
        apiKey: 'IZG9U3nkl3U1lWWQ5Sq0'
      })

      const index = await client.getIndex('products')
      var locationFilter = []
      if(this.selectedLocation == 0) {
        this.allLocations.forEach(function(x) {
          locationFilter.push(`checkin_locations = ${x}`)
        })
      } else {
        locationFilter.push(`checkin_locations = ${this.selectedLocation}`)
      }

      this.loadingWorklist = true
      this.errorWorklist = false
      var filters = [locationFilter, ...this.filterFormData, 'id_channel = ' + this.selectedChannel]
      var facetDistribution = ['brand', 'gender', 'color', 'season', 'category_name', 'complete_session']
      const search = await index
        .search(
          this.searchString != '' ? this.searchString : '',
          {
            filter: filters,
            facets: facetDistribution,
            offset: this.pagination.offset || 0,
            limit: 100,
            sort: ["updated_at:desc"],
            // page: this.selectedMode == "Workflow" ? this.pagination.current_page : this.RMSpagination.current_page,
            // perPage: this.selectedMode == "Workflow" ? this.pagination.per_page : this.RMSpagination.per_page,
            // withPagination: true
          }
        )
      this.pagination = search

      const facets = await index.search('', {filter: filters, facets: facetDistribution})
      this.facets = facets.facetDistribution

      this.loadingWorklist = false
      this.errorWorklist = false
    },

    getRMSData: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data = ''
      if (search != '' || data != '') this.pagination.current_page = 1
      const url =
        '/reportdesk/report/rms?page=' +
        this.pagination.current_page +
        '&channel=' +
        this.selectedChannel +
        search

      this.loadingWorklist = true
      this.errorWorklist = false

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pagination = response.data.products
          self.loadingWorklist = false
        })
        .catch(function (error) {
          self.loadingWorklist = false
          self.errorWorklist = true
        })
    },

    exportReport (scope) {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''
      var data =
        this.filterFormData != '' ? this.filterFormData : new FormData()

      if (scope == 'scoped') {
        var url =
          '/reportdesk/report/worklist?page=' +
          this.pagination.current_page +
          '&channel=' +
          this.selectedChannel +
          '&location=' +
          this.selectedLocation +
          search
        data.append('is_export_scoped', 1)
      } else if (scope == 'quick_download') {
        var url = '/reportdesk/report/worklist?channel=' + this.selectedChannel
        data.append('is_export_quick_download', 1)
      } else if (scope == 'pending_products') {
        var url = '/reportdesk/report/worklist?channel=' + this.selectedChannel
        data.append('is_export_pending_products', 1)
      } else {
        var url = '/reportdesk/report/worklist?channel=' + this.selectedChannel
        data.append('is_export', 1)
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'Export Requested',
            show: true
          })
          self.$router.push('/reportdesk/reports/exported')
        })
        .catch(function (error) {
          self.$store.dispatch('showToastAPIError')
        })
    },
    toggleFilters: function () {
      this.toggleState.show = !this.toggleState.show
    },
    onChangeChannel: function () {
      this.getWorklistData()
    },
    onChangeMode: function () {
      if (this.selectedMode == 'RMS') {
        this.getRMSData()
      } else {
        this.getWorklistData()
      }
    }
  },
  computed: {
    toggleFilterState () {
      return this.toggleState
    },
    searchTyping () {
      return this.isTyping
    }
  },
  watch: {
    '$store.state.clientLocations': function () {
      this.renderTable('state')
    },
    columnFormData (val, oldVal) {},
    toastSettings (val, oldval) {},
    loadingWorklist () {
      return this.loadingWorklist
    },
    errorWorklist () {
      return this.errorWorklist
    },
    toggleState () {
      if (this.toggleState.show == false) {
        $('.rentals-list-w').toggleClass('hide-filters')
      }
    },
    searchTyping: debounce(function () {
      this.isTyping = false
      this.onChangeMode()
    }, 1000)
  }
}
</script>

<style scoped>
.rentals-list-w .rentals-list .list-controls .list-order:last-child {
  margin-left: 10px;
}
.export {
  margin-left: 10px;
}
.export-button {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: 0.72rem;
}
.btn-white:hover,
.btn-white:active,
.btn-white:focus,
.btn-white:visited {
  background-color: #ffffff;
  border: 1px solid #ddd;
  color: rgba(0, 0, 0, 0.4);
}
.btn-white,
.all-wrapper .fc-button {
  border: 1px solid #ddd;
}
.list-search {
  margin-left: auto;
}
.property-items {
  height: calc(100vh - 150px);
}
.rentals-list-w {
  display: flex;
  /* overflow: hidden; */
  height: calc(100vh - 54px);
  position: relative;
}

.filters-toggle {
  color: rgb(31, 97, 234) !important;
  cursor: pointer;
}

.rentals-list-w .rentals-list {
  width: 0vw !important;
}
.rentals-list-w .property-items.as-grid {
  overflow: scroll;
}
.form-control-sm {
  height: 25px;
}
</style>
